import { render } from "./instagram-notification-opt-in.vue?vue&type=template&id=07037322&scoped=true"
import script from "./instagram-notification-opt-in.vue?vue&type=script&lang=js"
export * from "./instagram-notification-opt-in.vue?vue&type=script&lang=js"

import "./instagram-notification-opt-in.vue?vue&type=style&index=0&id=07037322&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07037322"]])

export default __exports__